import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

const employeeService = {
    getEmployees: async() => {
        try {
            const response = await axiosInstance.get(API.employee.getMyEmployees);
            return response.data;
        } catch(error) {
            throw error;
        }
    },

    getEmployeeDetail: async(employeeId) => {
       try{
             const response = await axiosInstance.get(API.employee.employeeGetById(employeeId));
             return response.data ;
       } catch(error){
        throw error;
       }
    },

     getMyDetail: async() => {
       try{
             const response = await axiosInstance.get(API.employee.getMyDetail);
             return response.data ;
       } catch(error){
        throw error;
       }
    },

    getCompensations: async(employeeId) => {
       try{
             const response = await axiosInstance.get(API.employee.getCompensations(employeeId));
             return response.data ;
       } catch(error){
        throw error;
       }
    },

    getEmployement: async(employeeId) => {
       try{
             const response = await axiosInstance.get(API.employee.getEmployment(employeeId));
             return response.data ;
       } catch(error){
        throw error;
       }
    },

    getDirectReports: async(supervisorId) => {
       try{
             const response = await axiosInstance.get(API.employee.getHierDirectReports(supervisorId));
             return response.data ;
       } catch(error){
        throw error;
       }
    }
}

// Use a default export
export default employeeService;